import { css as _css } from "@emotion/core";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import PropTypes from 'prop-types';
import { makeMouseDragCallbacks } from '@domain-group/fe-allhomes-nuka-carousel';
import { PlayIcon, ThreeDimensionalIcon } from '@domain-group/fe-co-icon';
import MultiResolutionImage from '@domain-group/fe-co-multi-resolution-image';
import Item from '../../models/item';
import * as styles from './thumbnail.style';
import logEventForComponent from '../../utils/log-event-for-component';
import { jsx as ___EmotionJSX } from "@emotion/core";
var logEvent = logEventForComponent('Thumb');
var THUMBNAIL_DRAG_THRESHOLD = 25;
var ALT_TEXT = {
  VIDEO: 'Frame from video',
  VIRTUAL_TOUR: 'Virtual Tour',
  FLOORPLAN: 'Floor plan',
  PHOTO: 'Photograph'
};
var Thumbnail = _ref => {
  var selected = _ref.selected,
    item = _ref.item,
    onClick = _ref.onClick;
  return ___EmotionJSX("button", _extends({
    type: "button",
    css: styles.button,
    onClick: logEvent('onClick', onClick),
    onClickCapture: logEvent('onClickCapture'),
    onDragStartCapture: event => {
      event.preventDefault();
    }
  }, makeMouseDragCallbacks(THUMBNAIL_DRAG_THRESHOLD)), ___EmotionJSX(MultiResolutionImage, {
    src: item.srcThumb,
    css: /*#__PURE__*/_css([styles.thumbnail, selected && styles.selected]),
    title: item.title,
    alt: ALT_TEXT[item.type] || ALT_TEXT.PHOTO
  }), ['VIRTUAL_TOUR', 'VIDEO'].includes(item.type) && ___EmotionJSX("div", {
    css: styles.overlay
  }, item.type === 'VIDEO' ? ___EmotionJSX(PlayIcon, null) : ___EmotionJSX(ThreeDimensionalIcon, null)));
};
Thumbnail.propTypes = {
  item: PropTypes.shape(Item).isRequired,
  selected: PropTypes.bool,
  onClick: PropTypes.func
};
Thumbnail.defaultProps = {
  selected: false,
  onClick: () => {}
};
export default Thumbnail;